import "./clientSettings.scss";

import { observer, useLocalObservable } from "mobx-react";
import { Modal, Button, Popconfirm, Collapse, Input, Table, Tag } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faUpload } from "@fortawesome/free-solid-svg-icons";
import type { CollapseProps } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined, DownloadOutlined } from "@ant-design/icons";

const CompareSettingsModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {}, []);

  const state = useLocalObservable(() => ({
    searchText: "",
    setSearchText(value: any) {
      this.searchText = value;
    },
  }));

  const handleOK = () => {
    console.log("Submit");
    const { editProfile, currentProfile } = controller.clientSettingsModal;
    console.log("editProfile", editProfile);
    console.log("currentProfile", currentProfile);
    // form
    //   .validateFields()
    //   .then(() => {
    //     const formData = form.getFieldsValue();
    //     controller.processDemoData(formData);
    //     form.resetFields();
    //     controller.setSelectedDepots([]);
    //   })
    //   .catch(() => {});
  };

  const handleCancel = () => {
    controller.setClientSettingsModal("compareModalVisible", false);
  };

  const renderFooter = () => {
    let footer = [
      <Button key="return" type="primary" icon={<FontAwesomeIcon icon={faAngleLeft} />} onClick={handleCancel}>
        {t("lblCancel", "Cancel")}
      </Button>,
    ];

    footer.push(
      <Popconfirm title="Update Client Settings" description="Are you sure you want to update client settings?" onConfirm={handleOK} okText="Yes" cancelText="No" placement="topRight">
        <Button key="upload" onClick={() => handleOK()} icon={<FontAwesomeIcon icon={faUpload} />}>
          {t("lblSubmit", "Submit")}
        </Button>
      </Popconfirm>
    );

    return footer;
  };

  if (!controller.clientSettingsModal.compareModalVisible) {
    return null;
  }

  const flattenObject = (obj, prefix = "") => {
    let result = {};
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
        Object.assign(result, flattenObject(obj[key], `${prefix}${key}.`));
      } else {
        result[`${prefix}${key}`] = JSON.stringify(obj[key]);
      }
    }
    return result;
  };

  const getDiffTag = (status) => {
    switch (status) {
      case "added":
        return <Tag color="green">Added</Tag>;
      case "removed":
        return <Tag color="red">Removed</Tag>;
      case "modified":
        return <Tag color="gold">Modified</Tag>;
      default:
        return null;
    }
  };

  const processData = () => {
    const { editProfile, currentProfile } = controller.clientSettingsModal;
    const currentSettings = flattenObject(currentProfile);
    console.log(currentSettings);
    const updatedSettings = flattenObject(editProfile);
    console.log(updatedSettings);
    const allKeys = new Set([...Object.keys(currentSettings), ...Object.keys(updatedSettings)]);

    let results = Array.from(allKeys).map((key) => {
      const current = currentSettings[key] || "-";
      const updated = updatedSettings[key] || "-";
      let status = "unchanged";
      if (current !== updated) {
        status = current === "-" ? "added" : updated === "-" ? "removed" : "modified";
      }
      return { key, current, updated, status };
    });

    // if(results){
    results = results.filter(
      (item) => item.status !== "unchanged" //&& item.key.includes(searchText)
    );
    // }

    return results;
  };

  const findMatchingKey = (targetKey) => {
    const { dataStructure } = controller.clientSettingsModal;
    for (const section in dataStructure) {
      const match = dataStructure[section].find((item) => item.key === targetKey);
      if (match) {
        return { section, ...match };
      }
    }
    return null; // Return null if no match is found
  };

  const renderChangedValue = (text, record) => {
    console.log("text", text);
    console.log("record", record);
    let content = null;
    let keyStruct = findMatchingKey(record?.key);
    if (keyStruct.type) {
      switch (keyStruct.type) {
        case "checkbox": {
          content =
            text === "-" ? (
              <Tag color="volcano">N/A</Tag>
            ) : text === "true" ? (
              <CheckCircleOutlined type="check" style={{ color: "green" }} />
            ) : (
              <CloseCircleOutlined type="close" style={{ color: "red" }} />
            );
          break;
        }
        case "input": {
          content = text === "-" ? <Tag color="volcano">N/A</Tag> : JSON.stringify(text, null, 2);
          break;
        }
        case "dropdown": {
          content = text === "-" ? <Tag color="volcano">N/A</Tag> : JSON.stringify(text, null, 2);
          break;
        }
        case "multiselect": {
          content = text === "-" ? <Tag color="volcano">N/A</Tag> : JSON.stringify(text, null, 2);
          break;
        }
        case "timepicker": {
          content = text === "-" ? <Tag color="volcano">N/A</Tag> : JSON.stringify(text, null, 2);
          break;
        }
        default: {
          content = text === "-" ? <Tag color="volcano">N/A</Tag> : JSON.stringify(text, null, 2);
          break;
        }
      }
    }
    // return <span style={{ backgroundColor: record.status === "modified" ? "#fff3cd" : "transparent", padding: "2px 5px", borderRadius: 4 }}>{content}</span>;
    return <span>{content}</span>;
  };

  const columns = [
    {
      title: "Field",
      dataIndex: "key",
      key: "key",
      render: (text, record) => {
        return controller.formatText(text);
      },
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
      align: "center" as "center",
      render: (text, record) => renderChangedValue(text, record),
    },
    {
      title: "Updated",
      dataIndex: "updated",
      key: "updated",
      align: "center" as "center",
      render: (text, record) => renderChangedValue(text, record),
    },
    { title: "Status", dataIndex: "status", key: "status", align: "center" as "center", render: getDiffTag },
  ];

  return (
    <Modal
      title={"Compare Settings - " + controller.clientSettingsModal?.row?.clientRef}
      open={controller.clientSettingsModal.compareModalVisible}
      footer={renderFooter()}
      onCancel={handleCancel}
      okType="primary"
      onOk={handleOK}
      maskClosable={false}
      className={"clientSettingsModal"}
      okButtonProps={{ disabled: controller.postTypes.length === 0 }}
      width={"90%"}
      style={{ maxWidth: 800 }}
      centered={true}
      styles={{
        header: { borderBottom: "1px solid #0505050f", paddingBottom: 10 },
        body: { padding: 0, position: "relative", overflow: "auto" },
      }}
    >
      <Input placeholder="Search by key" value={state.searchText} onChange={(e) => state.setSearchText(e.target.value)} style={{ marginBottom: 10 }} />
      <Table columns={columns} dataSource={processData()} rowKey="key" />
      <Button
        icon={<DownloadOutlined />}
        // onClick={exportCSV}
        style={{ marginTop: 10 }}
      >
        Export CSV
      </Button>
    </Modal>
  );
});

export default CompareSettingsModal;
